import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports/reports.component';
import { LayoutModule } from '../shared/layout/layout.module';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { reportsRoutes } from './reports.routes';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ReportsService } from './reports.service';
import { StoreModule } from '@ngrx/store';
import { reportsReducer } from './reports.reducer';
import { EffectsModule } from '@ngrx/effects';
import { MetaDataReportsResolve } from './meta.data.reports.resolve';
import { OverallMetaDataReportsResolve } from './overall.meta.data.reports.resolve';
import { ProjectsResolve } from './projects.resolve';
import { CrazyCallConfigService } from '../lead-generation/shared/services/crazycall-config.service';
import { ReportsEffects } from './reports.effects';
import { MatButtonModule, MatCheckboxModule, MatSelectModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { BoxComponent } from '../shared/layout/box/box.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { UI_SWITCH_CONFIGURATION } from '../shared/utils/layoutUtils';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    SharedModule,
    RouterModule.forChild(reportsRoutes),
    TranslateModule,
    NgxPermissionsModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    StoreModule.forFeature('reports', reportsReducer),
    EffectsModule.forFeature([ReportsEffects]),
    UiSwitchModule.forRoot(UI_SWITCH_CONFIGURATION)
  ],
  declarations: [ReportsComponent],
  exports: [ReportsComponent],
  entryComponents: [BoxComponent],
  providers: [
    CrazyCallConfigService,
    ReportsService,
    MetaDataReportsResolve,
    OverallMetaDataReportsResolve,
    ProjectsResolve
  ]
})
export class ReportsModule {}
